export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}
let scrollPosition = 0;
export function lockScroll() {
    if (isScrollable()) {
        const width = getScrollbarWidth();
        document.body.style.paddingRight = `${width}px`;
    }

    scrollPosition = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
}

export function unlockScroll() {
    if (isScrollable()) {
        document.body.style.paddingRight = 'unset';
    }

    document.body.style.position = '';
    document.documentElement.style.overflow = 'visible';
    window.scrollTo(0, scrollPosition);
}

function isScrollable() {
    return document.body.scrollHeight > window.innerHeight;
}

function getScrollbarWidth() {
    const outer = document.createElement('div');

    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    if (outer.parentNode) {
        outer.parentNode.removeChild(outer);
    }

    return scrollbarWidth;
}

export function scrollToElementById(id: string, offset = 0, smooth = true) {
    const element = document.getElementById(id);
    element && scrollToElement(element, offset, smooth);
}

export function scrollToElementByClass(cls: string, offset = 0, smooth = true) {
    const element = document.getElementsByClassName(cls)[0];
    element && scrollToElement(element, offset, smooth);
}

export function scrollToElementByAttribute(
    attribute: string,
    value: any,
    offset = 0,
    smooth = true
) {
    const element = document.querySelector(`[${attribute}="${value}"]`);
    element && scrollToElement(element, offset, smooth);
}

export function scrollToElement(element: any, offset = 0, smooth = true) {
    const top = element.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: smooth ? 'smooth' : 'instant' });
}

export function scrollToElementIntoContainer(containerClass: string, elementClass: string) {
    const container: HTMLElement | null = document.querySelector(`.${containerClass}`);

    if (!container) return;

    const element: HTMLElement | null = container.querySelector(`.${elementClass}`);

    if (!element) return;

    container.scrollTo({
        top: element.offsetTop,
    });
}

export function isElementVisible(element: any, offset = 0) {
    const rect = element?.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // Calculate the offset-adjusted top and bottom positions
    const elementTopWithOffset = rect.top - offset;
    const elementBottomWithOffset = rect.bottom + offset;

    // Check if the element is 100% visible with the given offset
    const isTopVisible = elementTopWithOffset >= 0;
    const isBottomVisible = elementBottomWithOffset <= windowHeight;

    return isTopVisible && isBottomVisible;
}
